module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"Saving":"Сохраняю","Search":"Поиск","Most recent transactions":"Последние транзакции","Select category":"Выберите категорию","from":"из","Hide":"Скрыть","Unhide":"Показать"}}')
  delete Component.options._Ctor
}
